import './App.css';
import { useState, useEffect } from 'react'; 
import { NavBar } from './Components/Headers/NavBar';
import 'bootstrap/dist/css/bootstrap.min.css';
import Hero from './Components/Headers/Hero';
import SummaryContainer from './Components/Containers/SummaryContainer';
import ProjectCarousel from './Components/Containers/ProjectCarousel'




function App() {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [scrollYPos, setScrollYPos] = useState(window.scrollY);

  useEffect(() => {
    const eventListener = window.addEventListener('scroll', () => {
      setScrollYPos(window.scrollY);
    });

    return () => {
      window.removeEventListener('scroll', eventListener);
    }
  }, []);
  
  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    pt: 2,
    px: 4,
    pb: 3,
  };
/*
  return (
    <div className="App" style={{height:'3000px'}} >
      <div style={{height:'300px'}}></div>
      <Button sx={{ opacity: 1 - (scrollYPos / (window.innerHeight / 4))}} variant ='contained' onClick={() => setIsModalVisible(!isModalVisible)}>GIMME THE MODAL</Button>
      <Modal
        open={isModalVisible}
        onClose={() => setIsModalVisible(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Text in a modal
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            Duis mollis, est non commodo luctus, nisi erat porttitor ligula.
          </Typography>
        </Box>
      </Modal>
    </div>
  );
  */
  
  const summaryIntro = "Welcome to my website! My name is Tori, and I am a versatile software engineer, with a strong background in game development. I adapt to team needs, contributing across programming, design, and QA to deliver high-quality player experiences on all platforms.";
  const summaryCloser = "I have a personal understanding of the player experience, and a drive to use my skills and knowledge to craft meaningful experiences. With me on the team, making games is as fun as playing them. ";


  return (
    <div className="App bg-dark">

      //fix nav bar?
      <Hero></Hero>

      <SummaryContainer summaryintro={summaryIntro} summarycloser={summaryCloser} ></SummaryContainer>
      <ProjectCarousel></ProjectCarousel>

    </div>
  );
}

export default App;
